// extracted by mini-css-extract-plugin
export var section = "speak-module--section--1fdOq";
export var head = "speak-module--head--R9iqC";
export var head_svg = "speak-module--head_svg--2mJaQ";
export var title = "speak-module--title--2RuHk";
export var subtitle = "speak-module--subtitle--3uFwl";
export var illustration = "speak-module--illustration--2acIY";
export var illustration_inner = "speak-module--illustration_inner--2frLL";
export var topSvgMobile = "speak-module--topSvgMobile--3Y_Ns";
export var jsAnimInit = "speak-module--jsAnimInit--1uAsH";